import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { funnelApi } from '../api/funnel-api';
import { FunnelStageInfo, FunnelStage } from '../types/crm-types';
import {
  fetchFunnelStages,
  fetchFunnelStageInfo,
  fetchFunnelStageValues,
} from './funnel-slice';

// === SAGA WORKERS ===

function* fetchFunnelStagesSaga() {
  try {
    
    const response: { data: FunnelStageInfo[] } = yield call(funnelApi.getFunnelStages);
    
    
    yield put({
      type: fetchFunnelStages.fulfilled.type,
      payload: response.data,
    });
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'Error al cargar las etapas del funnel';
    
    yield put({
      type: fetchFunnelStages.rejected.type,
      payload: errorMessage,
    });
  }
}

function* fetchFunnelStageInfoSaga(action: PayloadAction<string>) {
  try {
    const stage = action.payload;
    
    const response: { data: FunnelStageInfo | null } = yield call(funnelApi.getFunnelStageInfo, stage);
    
    
    yield put({
      type: fetchFunnelStageInfo.fulfilled.type,
      payload: response.data,
    });
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'Error al cargar la información de la etapa';
    
    yield put({
      type: fetchFunnelStageInfo.rejected.type,
      payload: errorMessage,
    });
  }
}

function* fetchFunnelStageValuesSaga() {
  try {
    
    const response: { data: FunnelStage[] } = yield call(funnelApi.getFunnelStageValues);
    
    
    yield put({
      type: fetchFunnelStageValues.fulfilled.type,
      payload: response.data,
    });
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'Error al cargar los valores de las etapas';
    
    yield put({
      type: fetchFunnelStageValues.rejected.type,
      payload: errorMessage,
    });
  }
}

// === SAGA WATCHERS ===

function* watchFetchFunnelStages() {
  yield takeLatest(fetchFunnelStages.pending.type, fetchFunnelStagesSaga);
}

function* watchFetchFunnelStageInfo() {
  yield takeLatest(fetchFunnelStageInfo.pending.type, fetchFunnelStageInfoSaga);
}

function* watchFetchFunnelStageValues() {
  yield takeLatest(fetchFunnelStageValues.pending.type, fetchFunnelStageValuesSaga);
}

// === ROOT SAGA ===

export function* funnelSaga() {
  yield takeLatest(fetchFunnelStages.pending.type, fetchFunnelStagesSaga);
  yield takeLatest(fetchFunnelStageInfo.pending.type, fetchFunnelStageInfoSaga);
  yield takeLatest(fetchFunnelStageValues.pending.type, fetchFunnelStageValuesSaga);
}

// === EXPORTS ===

export {
  fetchFunnelStagesSaga,
  fetchFunnelStageInfoSaga,
  fetchFunnelStageValuesSaga,
  watchFetchFunnelStages,
  watchFetchFunnelStageInfo,
  watchFetchFunnelStageValues,
};
